import React, { useEffect, useRef } from 'react';
import { Routes, Route } from 'react-router-dom';
import TopNav from '../../../components/Admin/NavbarAdmin';
import AdminSideNav from '../../../components/Admin/AdminSideNav';

// You can pass Admin and logout props into this wrapper
export default function AdminWrapper({ Admin, handleAdminLogout, children }) {
  const timeoutRef = useRef(null);
  // const INACTIVITY_LIMIT = 20 * 60 * 1000; 
  const INACTIVITY_LIMIT = 60 * 60 * 1000; // 1 hour

// const INACTIVITY_LIMIT = 1 * 60 * 1000; 

  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      handleAdminLogout(); // Log out user after inactivity
    }, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <>
      <TopNav />
      <AdminSideNav Admin={Admin} logout={handleAdminLogout} />
      {children}
    </>
  );
}
